import LayoutTerms from "components/LayoutTerms";
import { privacyPolicy } from "utils/constans";

const PrivacyPolicy = () => {
  return (<LayoutTerms terms={privacyPolicy} title={"PRIVACY POLICY"}/>);
};
export default PrivacyPolicy;
